function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect, useContext, useRef, CSSProperties } from 'react';
import cn from 'classnames';
import { Notification, INotificationProps } from '../Notification';
import { NotificationProviderContext } from './NotificationProvider';
require("./NotificationsList.css");
var styles = {
  "Root": "NotificationsList-module-Root_2qp",
  "isMobile": "NotificationsList-module-isMobile_1oa",
  "Element": "NotificationsList-module-Element_1YZ",
  "PseudoElement": "NotificationsList-module-PseudoElement_3PX",
  "animationIn": "NotificationsList-module-animationIn_7WR",
  "animationOut": "NotificationsList-module-animationOut_2MU",
  "showPseudoElement": "NotificationsList-module-showPseudoElement_10a",
  "hidePseudoElement": "NotificationsList-module-hidePseudoElement_1T-"
};
export const NotificationsList = ({
  className,
  controlRef,
  innerRef,
  style,
  notifications = [],
  isMobile = undefined,
  ...props
}) => {
  const {
    notificationsList,
    pushNotification,
    showNextElement
  } = useContext(NotificationProviderContext);
  const [animation, setAnimation] = useState('');
  const current = notificationsList[0];
  const screenWidth = useRef(window.screen.width);
  const mobileBreakpoint = 767;
  if (typeof isMobile === 'undefined') {
    isMobile = screenWidth.current <= mobileBreakpoint;
  }
  useEffect(() => {
    pushNotification(notifications);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const length = notificationsList.length;
    const timer = setTimeout(() => {
      if (length > 0 && animation !== 'Out') {
        setAnimation('In');
      }
    }, 100);
    if (length === 1) {
      setAnimation('Out');
    }
    if (!length) {
      setAnimation('');
    }
    return () => clearTimeout(timer);
  }, [notificationsList, animation]);

  /**
    Если isMobile, то
    выводится только первый
    элемент из массива, в ином случае
    выводятся все элементы
  */
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, styles[`animation${animation}`], {
      [styles.isMobile]: isMobile
    }, className),
    ref: innerRef || controlRef,
    style: style
  }, isMobile && current ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Notification, _extends({
    className: cn(current.className, styles.Element),
    title: current.title,
    message: current.message,
    action: current.action,
    showNext: showNextElement,
    isTemporary: current.isTemporary,
    timer: current.timer,
    id: current.id,
    addonBefore: current.addonBefore,
    addonBottom: current.addonBottom,
    variant: current.variant,
    style: current.style
  }, props)), /*#__PURE__*/React.createElement("div", {
    className: styles.PseudoElement
  })) : notificationsList.map((el, index) => /*#__PURE__*/React.createElement(Notification, _extends({
    key: index,
    className: cn(el.className, styles.Element),
    title: el.title,
    message: el.message,
    action: el.action,
    isTemporary: el.isTemporary,
    timer: el.timer,
    id: el.id,
    addonBefore: el.addonBefore,
    addonBottom: el.addonBottom,
    variant: el.variant,
    style: el.style
  }, props))));
};
if (process.env.NODE_ENV !== 'production') {
  NotificationsList.displayName = 'NotificationsList';
}